import { RECEIVE_USER_FILES, REQUEST_USER_FILES } from '../actions'

export default (
    state = {
        fetchSuccessful: null,
        items: [],
        isFetching: false,
        shouldFetch: true,
    },
    action
) => {
    const { type, data } = action

    switch (type) {
        case REQUEST_USER_FILES:
            return { ...state, isFetching: true }

        case RECEIVE_USER_FILES:
            return { ...state, ...data, isFetching: false }

        default:
            return state
    }
}
